import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useConfirm } from 'legacy/lut/components/shared/Confirm/useConfirm'
import { SIGNATURE_DROP_DIALOG } from 'legacy/lut/components/widgets/public/partner360/planning/components/powerServicesMembership'
import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { useFinSobDropSignature } from 'partner360/hooks/finSob/useFinSobDropSignature'

import { IWizardStep } from '../../models/IWizardStep'

import { TRANSLATION_KEYS } from './translations'

import styles from './NotApplicableStep.module.scss'

interface INotApplicableStepProps {
  activeStep: IWizardStep
  partnerId: string
  fYear: number
  programType: ProgramTypes
  isEditMode: boolean
  onChangeStepApplicable: (item: IWizardStep, isNeedDropCommitment?: boolean) => void
}

export const NotApplicableStep = ({
  activeStep,
  onChangeStepApplicable,
  isEditMode,
}: INotApplicableStepProps) => {
  /** ------------------------- Hooks ------------------------- */

  const { isNeedToShowSignDialog } = useFinSobDropSignature()
  const { confirm } = useConfirm()

  /** ------------------------- User actions handlers ------------------------- */

  const switchOn = useCallback(async () => {
    if (isNeedToShowSignDialog) {
      const isNeedDropCommitment = await confirm(SIGNATURE_DROP_DIALOG)
      if (!isNeedDropCommitment) {
        return
      }
    }
    onChangeStepApplicable(activeStep, isNeedToShowSignDialog)
  }, [activeStep, confirm, isNeedToShowSignDialog, onChangeStepApplicable])

  /** ------------------------- Render ------------------------- */

  return (
    <div className={styles.notApplicableItem}>
      <p>
        <Translation span text={`${activeStep.category}-editor`} />
        &nbsp;
        <Translation span text={TRANSLATION_KEYS.categoryIsNotApplicable} />
      </p>
      {isEditMode && (
        <Button onClick={switchOn} variant={'outlined'}>
          <Translation span text={TRANSLATION_KEYS.switchOn} />
        </Button>
      )}
    </div>
  )
}
